import React from 'react';
export function Footer() {
  return <footer className="border-t border-ink-line bg-ink-bg px-4 py-6" data-id="element-66" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-3xl text-center text-[11px] leading-snug text-ink-text sm:text-xs" data-id="element-67" data-mp="3gfiu2hdxs9dl">
        <p className="font-display font-bold uppercase text-white" data-id="element-68" data-mp="32ovwisjwwpj3">
          © 2026 Speech Therapy Pro™ — All Rights Reserved.
        </p>
        <p className="mt-2" data-id="element-69" data-mp="36nd5lhmw8a35">
          The information provided is intended for educational purposes and as a professional
          clinical resource for Speech Therapists and Speech-Language Pathologists. Clinicians
          should always apply professional judgment, individualize treatment according to each
          patient's needs, and follow current clinical guidelines and ethical standards when
          using any resource included in this system.
        </p>
        <p className="mt-2" data-id="element-70" data-mp="29ydwk0ehj49w">Terms &amp; Conditions • Privacy Policy • Contact</p>
        <p className="mt-1" data-id="element-71" data-mp="2eyjprl0ekyu3">
          Support:{' '}
          <a href="mailto:kitonline27@gmail.com" className="text-gold hover:text-gold-hover" data-id="element-72" data-mp="2evx98vvjb8zq">
            kitonline27@gmail.com
          </a>
        </p>
      </div>
    </footer>;
}